import React from 'react';

function Booking() {
  return <div className="container mt-5"><h2>Booking Page</h2></div>;
}

export default Booking;